module.exports = __webpack_public_path__ + "img/SES_150250006.4a0602b2.jpg";